import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

import "./McaCourse.css";
import {
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
} from "react-icons/fa";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";
import { FaUniversity, FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaChartLine, FaHandshake, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";

export default function BcomCourse() {
  const careers = [
    {
      icon: "💻",
      title: "Accountant",
    },
    {
      icon: "🌐",
      title: "Financial Analyst",
    },
    {
      icon: "📊",
      title: "Tax Consultant",
    },
    {
      icon: "🖥️",
      title: "Auditor",
    },
    {
      icon: "🗄️",
      title: "Banking Professional",
    },
    {
      icon: "☁️",
      title: "Corporate Finance Executive",
    },
    {
      icon: "🔐",
      title: "Cybersecurity Analyst",
    },
    {
      icon: "📂",
      title: "IT Project Manager",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is a B.Com course?",
      answer:
        "B.Com (Bachelor of Commerce) is an undergraduate program that provides knowledge in accounting, finance, taxation, economics, and business management.",
    },
    {
      question: "What is the duration of a B.Com program?",
      answer:
        "The standard B.Com program is typically 3 years long, divided into 6 semesters. Some universities also offer honors or specialized B.Com courses.",
    },
    {
      question: "What are the eligibility criteria for B.Com?",
      answer:
        "Candidates must have completed their 10+2 (or equivalent) from a recognized board, usually with commerce, science, or arts stream.",
    },
    {
      question: "What specializations are available in B.Com?",
      answer:
        "B.Com students can specialize in areas like Accounting & Finance, Taxation, Banking & Insurance, E-Commerce, and International Business.",
    },
    {
      question: "What career options are available after B.Com?",
      answer:
        "Graduates can pursue careers in accounting, finance, banking, auditing, taxation, business analytics, or further studies like M.Com, MBA, or professional certifications like CA, CMA, or ACCA.",
    },
    {
      question: "Is B.Com available via distance learning or open schooling?",
      answer:
        "Yes, many universities and boards offer B.Com programs through distance learning or open schooling for students who cannot attend regular classes.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Study While You Work",
      details:
        " Pursue your B.Com distance education in Bangalore while continuing your job or personal commitments. The flexible format allows you to balance academics, work, and daily life efficiently.",
    },
    {
      icon: <FaUser />,
      title: "Access Anytime, Anywhere",
      details:
        "Enjoy 24/7 access to online B.Com courses in Bangalore, including lectures, digital materials, and recorded sessions, enabling you to study conveniently from home, office, or while traveling.",
    },
    {
      icon: <FaDollarSign />,
      title: "Lower Cost, Same Degree",
      details:
        " Affordable and career-focused, UGC-approved B.Com online programs provide the same valid and recognized degree as regular colleges, but at a fraction of the overall cost.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        " Enroll in programs offered by UGC-DEB recognized distance B.Com colleges in Bangalore, ensuring your degree holds credibility for jobs, higher studies, and government or corporate career opportunities.",
    },
    {
      icon: <FaTruck />,
      title: "Career-Aligned Curriculum",
      details:
        " The syllabus includes Financial Accounting, Business Law, Economics, Corporate Finance, and Taxation—designed to prepare students for careers in finance, auditing, banking, or business management.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        " Study at your own pace with access to digital study materials, faculty guidance, and responsive academic support from best B.Com distance learning colleges in Bangalore.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        "The B.Com distance education program is 3 years long, divided into 6 semesters, ensuring a structured learning journey for students pursuing commerce-related careers.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        " Offered through online B.Com courses in Bangalore or correspondence mode, this program is convenient for working professionals and students who prefer flexible study schedules.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        "Applicants must have completed 10+2 or an equivalent qualification from a recognized board to enroll in UGC-approved B.Com distance education programs.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        "Courses are offered by UGC-DEB approved universities, ensuring credibility for both private and government jobs, higher studies, and career growth in commerce fields.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        " The syllabus covers Accounting, Business Law, Economics, Corporate Studies, and Taxation, blending theoretical learning with practical applications for strong career readiness.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        " Students gain access to study materials, academic support, digital resources, and flexible exam schedules, making learning easy and effective from any location.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          B.Com Distance Education in Bangalore | UGC Approved Online
        </title>
        <meta
          name="description"
          content="Enroll in B.Com distance education in Bangalore. UGC-approved B.Com online courses & correspondence programs from the best distance learning colleges."
        />
      </Helmet>

      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Bachelor of Commerce (B.Com){" "}
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/909175-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "110px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              B.Com Distance Education – Build a Strong Foundation in Commerce{" "}
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Bachelor of Commerce (B.Com) distance education program is an
              excellent choice for students and working professionals who want
              to pursue careers in finance, accounting, taxation, or business
              while enjoying flexible study options. This 3-year undergraduate
              degree from UGC-approved B.Com distance education universities
              ensures both academic credibility and industry relevance. Through
              the online B.Com courses in Bangalore, learners gain expertise in
              Financial Accounting, Business Law, Economics, Taxation, and
              Corporate Studies. The program equips students with the practical
              skills required for careers in banking, auditing, consulting, or
              corporate finance. Enrolling in B.Com correspondence courses in
              Bangalore provides flexibility to study at your own pace, access
              digital learning materials, and receive expert academic support.
              Recognized among the best B.Com distance learning colleges in
              Bangalore, this program offers affordability, convenience, and
              quality education—making it a career-focused choice for aspiring
              commerce professionals.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of the B.Com Distance Education Program
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India.
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              B.Com Distance Education – Step Into the World of Business &
              Finance
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The B.Com distance education in Bangalore program is designed for
              students who want to build a strong foundation in commerce,
              accounting, and business management while enjoying the flexibility
              to learn from anywhere. Whether you’re a 12th-grade graduate or a
              working professional looking to upgrade qualifications, this
              course offers the ideal balance of academic knowledge and
              practical skills. Covering key subjects like Financial Accounting,
              Business Law, Economics, Corporate Finance, and Taxation, the
              program equips learners for diverse career paths in banking,
              finance, auditing, taxation, and business operations. The
              curriculum is industry-aligned and regularly updated to match
              evolving job market requirements. Offered by UGC-approved B.Com
              distance learning colleges in Bangalore, the degree ensures
              credibility and recognition across sectors. With flexible
              schedules, self-paced study options, and access to digital
              resources, the best online B.Com colleges make it possible to earn
              a valuable degree without compromising your current lifestyle or
              career.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose B.COM via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your B.Com Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance B.Com programs are becoming highly popular among
                students and working professionals who wish to build strong
                commerce foundations without interrupting their career or
                personal schedules.
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">
              Career Opportunities After B.COM
            </h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning a B.Com through distance education opens up diverse career
              opportunities in the fields of commerce, finance, and business.
              With a strong foundation in accounting, economics, taxation, and
              business management, B.Com graduates are in high demand across
              various sectors including banking, corporate firms, and government
              organizations.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-3">
                Take the Next Step with Our Distance B.Com Program
              </h1>
              <p className="text-muted fs-5">
                Looking to build a rewarding career in commerce, finance, or
                business management? Our B.Com distance education in Bangalore
                is the perfect foundation for your professional journey. This
                UGC-approved program combines flexibility, affordability, and
                academic excellence, allowing you to learn anytime, anywhere.
                With a comprehensive curriculum covering Accounting, Business
                Law, Economics, and Taxation, our program equips students with
                practical knowledge and job-ready skills. Whether you’re a
                recent 12th-grade graduate or a working professional, the best
                B.Com distance learning colleges in Bangalore offer the perfect
                platform to upgrade your qualifications. Choose from online
                B.Com courses in Bangalore designed to match industry needs and
                career aspirations. Take the next step today and secure your
                future in banking, accounting, corporate sectors, or
                entrepreneurship with a recognized B.Com correspondence course
                in Bangalore.
              </p>
            </Col>
          </Row>
        </Container>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance B.Com Program</h3>
            <p>
              Looking to build a strong career in commerce, finance, or business
              management? Our Distance B.Com program is the perfect starting
              point. Designed for flexibility and accessibility, this program
              allows you to study from anywhere while gaining in-depth knowledge
              in subjects like Accounting, Economics, Business Law, and
              Taxation. Whether you’re a recent school graduate or a working
              professional aiming to enhance your qualifications, the B.Com
              distance program equips you with the skills and degree needed for
              roles in banking, accounting, corporate sectors, and
              entrepreneurship. Take the next step toward a rewarding career —
              start your journey with us today.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
